import React, { useContext, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../../assets/css/customer/blog/BlogPage.css";
import AppContext from '../../../context/AppContext';
import axios from 'axios';

const BlogDetail = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);

  const viewBlog = () => {
    setPageLoading(true);
    axios
      .get(`${baseUrl}/blogs/viewBlog/${id}`)
      .then((res) => {
        console.log("*********log from blog detail", res.data);
        const b = res.data.data;
        setBlog({
          id: b.id,
          title: b.title,
          excerpt: b.Excerpt,
          content: b.content,
          category: b.category,
          date: b.date,
          author: b.author,
          image: `${baseUrlForFile}/${b.image}`,
        });
      })
      .catch((err) => { console.log(err) })
      .finally(() => setPageLoading(false));
  };

  useEffect(() => {
    viewBlog();
    window.scrollTo({ top: 0 });
  }, [id]);

  if (pageLoading) {
    return (
      <div className="blg-detail-loading">
        <p>Loading...</p>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="blg-detail-loading">
        <p>Blog not found.</p>
        <button className="blg-read-more" onClick={() => navigate('/blogs')}>
          ← Back to Blogs
        </button>
      </div>
    );
  }

  return (
    <div className="blg-root">
      {/* ── Hero ── */}
      <div className="blg-hero">
        <img
          src={blog.image}
          alt={blog.title}
          className="blg-hero-img"
        />
        <div className="blg-hero-overlay">
          <span className="blg-modal-category">{blog.category}</span>
          <h1 className="blg-hero-title">{blog.title}</h1>
        </div>
      </div>

      <div className="blg-page">
        <div className="blg-detail-wrap">
          <button className="blg-read-more" onClick={() => navigate('/blogs')}>
            ← Back to Blogs
          </button>

          <div className="blg-post-meta" style={{ marginTop: '20px' }}>
            <span className="blg-meta-item">{blog.date}</span>
            <span className="blg-meta-dot" />
            <span className="blg-meta-item">{blog.author}</span>
          </div>

          <div className="blg-divider" />

          {blog.excerpt && (
            <p className="blg-post-excerpt" style={{ fontStyle: 'italic' }}>
              {blog.excerpt}
            </p>
          )}

          <div
            className="blg-detail-content"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;